import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoGoogle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_9963_62022)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M5.57533 0.526614C3.97668 1.0812 2.59801 2.13382 1.64182 3.52987C0.685628 4.92591 0.202319 6.59179 0.262883 8.28282C0.323447 9.97385 0.92469 11.6009 1.9783 12.925C3.03191 14.249 4.48235 15.2003 6.11658 15.6391C7.44148 15.981 8.82959 15.996 10.1616 15.6829C11.3682 15.4118 12.4838 14.8321 13.3991 14.0004C14.3517 13.1083 15.0431 11.9735 15.3991 10.7179C15.7858 9.35243 15.8547 7.91654 15.6003 6.52036H8.16033V9.60661H12.4691C12.383 10.0988 12.1984 10.5687 11.9265 10.9879C11.6546 11.4072 11.3009 11.7672 10.8866 12.0466C10.3605 12.3948 9.76736 12.629 9.14533 12.7341C8.52151 12.8501 7.88165 12.8501 7.25783 12.7341C6.62552 12.6035 6.02738 12.3426 5.50158 11.9679C4.65677 11.3698 4.02243 10.5203 3.68908 9.54036C3.35019 8.54209 3.35019 7.45989 3.68908 6.46161C3.92636 5.76188 4.31862 5.12478 4.83658 4.59786C5.42932 3.9838 6.17975 3.54486 7.00552 3.32921C7.8313 3.11356 8.70053 3.12953 9.51783 3.37536C10.1563 3.57127 10.7402 3.91371 11.2228 4.37536C11.7087 3.89203 12.1937 3.40745 12.6778 2.92161C12.9278 2.66036 13.2003 2.41161 13.4466 2.14411C12.7097 1.45851 11.8449 0.924994 10.9016 0.574114C9.18371 -0.0496489 7.30405 -0.0664119 5.57533 0.526614Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.5725 0.526245C7.30108 -0.067184 9.18074 -0.0508623 10.8987 0.572495C11.8422 0.925759 12.7067 1.46184 13.4425 2.14999C13.1925 2.41749 12.9288 2.66749 12.6737 2.92749C12.1888 3.41166 11.7042 3.89416 11.22 4.37499C10.7374 3.91334 10.1535 3.5709 9.515 3.37499C8.69797 3.1283 7.82877 3.1114 7.00277 3.32617C6.17678 3.54094 5.42589 3.97907 4.8325 4.59249C4.31454 5.11941 3.92228 5.75652 3.685 6.45624L1.09375 4.44999C2.02126 2.6107 3.62719 1.20377 5.5725 0.526245Z",
					fill: "#E33629"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.408903 6.4377C0.548077 5.74741 0.77931 5.07894 1.0964 4.4502L3.68765 6.46145C3.34876 7.45972 3.34876 8.54192 3.68765 9.5402C2.82432 10.2069 1.96057 10.8769 1.0964 11.5502C0.302841 9.97059 0.0608185 8.17082 0.408903 6.4377Z",
					fill: "#F8BD00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.15681 6.51855H15.5968C15.8512 7.91473 15.7823 9.35062 15.3956 10.7161C15.0396 11.9717 14.3482 13.1065 13.3956 13.9986C12.5593 13.3461 11.7193 12.6986 10.8831 12.0461C11.2977 11.7664 11.6515 11.4059 11.9234 10.9862C12.1954 10.5665 12.3798 10.0962 12.4656 9.60355H8.15681C8.15556 8.57605 8.15681 7.5473 8.15681 6.51855Z",
					fill: "#587DBD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.09375 11.55C1.95792 10.8834 2.82167 10.2134 3.685 9.54004C4.01901 10.5203 4.65426 11.3699 5.5 11.9675C6.02744 12.3405 6.62687 12.5993 7.26 12.7275C7.88382 12.8436 8.52368 12.8436 9.1475 12.7275C9.76953 12.6224 10.3627 12.3882 10.8888 12.04C11.725 12.6925 12.565 13.34 13.4012 13.9925C12.4861 14.8247 11.3705 15.4049 10.1637 15.6763C8.83176 15.9894 7.44365 15.9744 6.11875 15.6325C5.07088 15.3528 4.09209 14.8595 3.24375 14.1838C2.34591 13.4708 1.61254 12.5724 1.09375 11.55Z",
					fill: "#319F43"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9963_62022",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogoGoogle);
export { ForwardRef as ReactComponent };
